export const testSavedViews = [
  {
    title: "All Orders",
    target: "allOrders",
    active:true,
    canRemove: false,
    canEdit: false,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": false
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": true,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
                "dateRangeEndVal": "05/31/2017",
                "dateRangeStartVal": "05/30/2017"
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "doorStatus",
        title: "Actions",
        active: true,
        canToggle: false
      },
      {
        data: "dockDoorName",
        title: "Dock Door Name",
        active: true,
        canToggle: true
      },
      {
        data: "doorUses",
        title: "Door Uses",
        active: true,
        canToggle: true
      },
      {
        data: "appointmentTypes",
        title: "Appointment Types",
        active: true,
        canToggle: true
      },
      {
        data: "dockStatus",
        title: "Status",
        active: true,
        canToggle: true
      },
      {
        data: "scheduleType",
        title: "Schedule Type",
        active: true,
        canToggle: true
      },
      {
        data: "dateModified",
        title: "Date Modified",
        active: true,
        canToggle: false
      },
      {
        data: "modifiedBy",
        title: "Modified By",
        active: true,
        canToggle: true
      }
    ]
  },
  {
    title: "Saved Search 1",
    target: "savedSearchOne",
    active:false,
    canRemove: true,
    canEdit: true,
    filters: [
      {
        "filterGroup": "Inventory Status",
        "filterGroupType": "checkbox",
        "filterGroupName": "status",
        "filterGroupInputs": [
          {
            "filterTitle": "In Stock",
            "filterValue": "inStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Low Stock",
            "filterValue": "lowStock",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterTitle": "Out of Stock",
            "filterValue": "outOfStock",
            "filterOperator": "equal",
            "active": true
          },
        ],
      },
      {
        "filterGroup": "Date Range",
        "filterGroupType": "radio",
        "filterGroupName": "fixedRange",
        "filterGroupInputs": [
          {
            "filterName": "fixedRange",
            "filterTitle": "Today",
            "filterValue": "today",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Yesterday",
            "filterValue": "yesterday",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 7 Days",
            "filterValue": "lastSevenDays",
            "filterOperator": "equal",
            "active": false
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Last 60 Days (Default)",
            "filterValue": "lastSixtyDays",
            "filterOperator": "equal",
            "active": true
          },
          {
            "filterName": "fixedRange",
            "filterTitle": "Custom Date Range",
            "filterValue": "customRange",
            "filterOperator": "equal",
            "active": false,
            "childFilters":[
              {
                "filterGroup": "Date Range",
                "filterGroupType": "dateRange",
                "filterGroupName": "dateRange",
                "dateRangeNameStart": "startDate",
                "dateRangeNameEnd": "endDate",
              }
            ]
          },
        ],
      }
    ],
    columns: [
      {
        data: "doorStatus",
        title: "Actions",
        active: true,
        canToggle: false
      },
      {
        data: "dockDoorName",
        title: "Dock Door Name",
        active: true,
        canToggle: true
      },
      {
        data: "doorUses",
        title: "Door Uses",
        active: true,
        canToggle: true
      },
      {
        data: "appointmentTypes",
        title: "Appointment Types",
        active: true,
        canToggle: true
      },
      {
        data: "dockStatus",
        title: "Status",
        active: true,
        canToggle: true
      },
      {
        data: "scheduleType",
        title: "Schedule Type",
        active: true,
        canToggle: true
      },
      {
        data: "dateModified",
        title: "Date Modified",
        active: true,
        canToggle: false
      },
      {
        data: "modifiedBy",
        title: "Modified By",
        active: true,
        canToggle: true
      }
    ]
  }
]

export const testNewSavedView = {
  title: "New Saved Search",
  target: "savedViewUpdatedTarget",
  active:true,
  canRemove: true,
  canEdit: true,
  filters: [
    {
      "filterGroup": "Inventory Status",
      "filterGroupType": "checkbox",
      "filterGroupName": "status",
      "filterGroupInputs": [
        {
          "filterTitle": "In Stock",
          "filterValue": "inStock",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterTitle": "Low Stock",
          "filterValue": "lowStock",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterTitle": "Out of Stock",
          "filterValue": "outOfStock",
          "filterOperator": "equal",
          "active": true
        },
      ],
    },
    {
      "filterGroup": "Date Range",
      "filterGroupType": "radio",
      "filterGroupName": "fixedRange",
      "filterGroupInputs": [
        {
          "filterName": "fixedRange",
          "filterTitle": "Today",
          "filterValue": "today",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Yesterday",
          "filterValue": "yesterday",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Last 7 Days",
          "filterValue": "lastSevenDays",
          "filterOperator": "equal",
          "active": false
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Last 60 Days (Default)",
          "filterValue": "lastSixtyDays",
          "filterOperator": "equal",
          "active": true
        },
        {
          "filterName": "fixedRange",
          "filterTitle": "Custom Date Range",
          "filterValue": "customRange",
          "filterOperator": "equal",
          "active": false,
          "childFilters":[
            {
              "filterGroup": "Date Range",
              "filterGroupType": "dateRange",
              "filterGroupName": "dateRange",
              "dateRangeNameStart": "startDate",
              "dateRangeNameEnd": "endDate",
            }
          ]
        },
      ],
    }
  ],
  columns: [
    {
      data: "doorStatus",
      title: "Actions",
      active: true,
      canToggle: false
    },
    {
      data: "dockDoorName",
      title: "Dock Door Name",
      active: true,
      canToggle: true
    },
    {
      data: "doorUses",
      title: "Door Uses",
      active: true,
      canToggle: true
    },
    {
      data: "appointmentTypes",
      title: "Appointment Types",
      active: true,
      canToggle: true
    },
    {
      data: "dockStatus",
      title: "Status",
      active: true,
      canToggle: true
    },
    {
      data: "scheduleType",
      title: "Schedule Type",
      active: true,
      canToggle: true
    },
    {
      data: "dateModified",
      title: "Date Modified",
      active: true,
      canToggle: false
    },
    {
      data: "modifiedBy",
      title: "Modified By",
      active: true,
      canToggle: true
    }
  ]
}


// WEBPACK FOOTER //
// ./src/pages/dockConfigurations/html/doorLookup/stores/savedViews.js